import { Outlet } from 'react-router';
import { BrandBlock } from '@/shared/ui/brand';

export function AuthLayout() {
  return (
    <div style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', background: 'var(--sgr-bg-sidebar)', padding: 'var(--sp-4)' }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--sp-5)' }}><BrandBlock logoHeight={40} align="center" /></div>
        <Outlet />
        <p style={{ textAlign: 'center', fontSize: 'var(--fs-xs)', color: 'var(--sgr-text-muted)', marginTop: 'var(--sp-5)' }}>Acceso exclusivo para personal autorizado de PASCOM.</p>
      </div>
    </div>
  );
}
